import { render } from "./InformationsPersonnelles.vue?vue&type=template&id=aa965654&scoped=true&ts=true"
import script from "./InformationsPersonnelles.vue?vue&type=script&lang=ts"
export * from "./InformationsPersonnelles.vue?vue&type=script&lang=ts"

import "./InformationsPersonnelles.vue?vue&type=style&index=0&id=aa965654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa965654"]])

export default __exports__